import * as React from 'react';
import {InferableComponentEnhancer} from 'recompose';
import createComputed from '../createComputed';

export interface Condition<FormData extends object, ConditionFields extends keyof FormData, P extends object = {}> {
  fieldNames: ConditionFields[];
  condition: (values: Pick<FormData, ConditionFields>) => boolean;
  props: P; // props that will added to component if field matches value;
}

function createConditional<FormData extends object, ConditionFields extends keyof FormData>(
  condition: Condition<FormData, ConditionFields>
): InferableComponentEnhancer<{}> {
  const {fieldNames, props} = condition;
  const conditionFunction = condition.condition as Condition<FormData, ConditionFields>['condition'];
  return function(WrappedComponent) {
    const Component = createComputed<FormData, ConditionFields>({
      fieldNames: fieldNames,
      propsGenerator: formValues => {
        if (conditionFunction(formValues)) return props;
        else return {};
      },
    })(WrappedComponent);
    return props => <Component {...props} />;
  };
}

export default createConditional;
